export const LAYOUT = {
  heroWidth: '55%',
  heroWidthLarge: '56.5%',
  formWidth: '45%',
  formWidthLarge: '43.5%',
} as const;
